import React from 'react';
import ScanOverview from './dispatch-scan/ScanOverview';
const base = 'dispatch_scan';

export default function ScanningBox({
    show,
    scannedItem,
    scannedItemSKU,
    scannedItemError,
    handleScan,
    loading,
    originalItemImageLink,
    itemImage,
    isCurrentPageFullScreen
}) {
    if (show) {
        return (
            <div
                className={isCurrentPageFullScreen ? `${base}__scan_box_full_screen` : `${base}__scan_box`}
            >
                <ScanOverview
                    scannedItem={scannedItem}
                    scannedItemSKU={scannedItemSKU}
                    scannedItemError={scannedItemError}
                    handleScan={handleScan}
                    loading={loading}
                    originalItemImageLink={originalItemImageLink}
                    itemImage={itemImage}
                    show={show}
                />
            </div>
        );
    } else {
        return <div></div>;
    }
}
